import React, { useState } from "react";
import Header from "../layouts/header/Header";
import Carousel from "./component/Carousel";
import NewAuthor from "./ui/NewAuthor";
import MainAuthorList from "./ui/MainAuthorList";
import Footer from "../layouts/footer/Footer";
import { indexWrapCss, mainTextCss } from "./css/Main.style";
import MobileText from "./component/MobileText";
import WebText from "./component/WebText";

interface Props {
    authors: any;
    carouselImages: any[];
    isMobile?: boolean;
    AddAuthorComponent: React.FC;
}



const MainLayout = ({ authors, carouselImages, isMobile = false, AddAuthorComponent }: Props) => {

    const [search, setSearch] = useState("");

    const onSearchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    };

    return (
        <div css={indexWrapCss}>
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag="author"
            />

            <main>
                {isMobile ? <MobileText /> : <WebText />}

                <Carousel imageData={carouselImages} />
                <NewAuthor authors={authors} />
                <AddAuthorComponent />
                <MainAuthorList />
            </main>
            <Footer />
        </div>
    );

}

export default MainLayout;
